export const productConstants = {

    GET_PRODUCTS_OF_PUBLIC_SHOP_REQUEST: "GET_PRODUCTS_OF_PUBLIC_SHOP_REQUEST",
    GET_PRODUCTS_OF_PUBLIC_SHOP_SUCCESS: "GET_PRODUCTS_OF_PUBLIC_SHOP_SUCCESS",
    GET_PRODUCTS_OF_PUBLIC_SHOP_ERROR: "GET_PRODUCTS_OF_PUBLIC_SHOP_ERROR",

}